import * as React from 'react'
import { IVehicleFilters } from 'src/types'
import FindIcon from '../icons/ui/Find'
import { Input } from '@mobiscroll/react-latest'

interface IVehiclesSearchProps {
  orgId: string
  type: string
  onInputChange: (params: IVehicleFilters) => void
}

const VehiclesSearch = (props: IVehiclesSearchProps) => {
  const handleInputChange = (e: any) => {
    const { onInputChange, orgId, type } = props
    onInputChange({ search: e.target.value, organizationId: orgId, type })
  }

  return (
    <div className='flex items-center mr3'>
      {/* <input className='w3-input mr1' type='text' onChange={handleInputChange} placeholder='License plate' /> */}
      <Input
        className='mr1 mobiscroll-input'
        type='text'
        onChange={handleInputChange}
        theme='ios'
        themeVariant='light'
        inputStyle='box'
        labelStyle='floating'
        placeholder={'License Plate'}
      />
      <FindIcon className='svg-stroke-grey3' />
    </div>
  )
}

export default VehiclesSearch



// WEBPACK FOOTER //
// ./src/components/vehicles/VehicleSearch.tsx